/**
 * "Nou de la ultima privire" pe coada Securitee > Incidents. Se tine in
 * browser (o comoditate a omului, nu stare de impartit): cel mai mare ID vazut
 * si cate detectii avea fiecare incident vazut. New = ID mai mare; Updated =
 * vazut, dar cu mai multe detectii. Fara ceas: detectiile vin cu intarziere.
 */
export type Freshness = 'new' | 'updated'

export interface Seen {
  maxId: number
  counts: Record<number, number>
}

const KEY = 'od-xdr-incidents-seen'
const KEEP = 500

export function freshness(rows: { ID: number; detections: number }[], seen: Seen | null): Map<number, Freshness> {
  const out = new Map<number, Freshness>()
  if (seen === null) return out
  for (const r of rows) {
    if (r.ID > seen.maxId) out.set(r.ID, 'new')
    else if (seen.counts[r.ID] !== undefined && r.detections > seen.counts[r.ID]!) out.set(r.ID, 'updated')
  }
  return out
}

/** Ce e vazut dupa privirea asta: randurile de acum peste cele de dinainte, cele mai noi `KEEP`. */
export function nextSeen(rows: { ID: number; detections: number }[], prev: Seen | null): Seen {
  const counts: Record<number, number> = { ...(prev?.counts ?? {}) }
  for (const r of rows) counts[r.ID] = r.detections
  const ids = Object.keys(counts).map(Number).sort((a, b) => b - a)
  const kept: Record<number, number> = {}
  for (const id of ids.slice(0, KEEP)) kept[id] = counts[id]!
  return { maxId: Math.max(prev?.maxId ?? 0, ...rows.map((r) => r.ID)), counts: kept }
}

export function readSeen(): Seen | null {
  try {
    const raw = JSON.parse(window.localStorage.getItem(KEY) ?? 'null') as Partial<Seen> | null
    return raw !== null && typeof raw.maxId === 'number' && typeof raw.counts === 'object' && raw.counts !== null ? { maxId: raw.maxId, counts: raw.counts } : null
  } catch {
    return null
  }
}

export function writeSeen(seen: Seen): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(seen))
  } catch {
    /* fara memorie in browser: semnele tin numai cat sta pagina deschisa */
  }
}
